import { render, staticRenderFns } from "./Tippings.vue?vue&type=template&id=e875e4bc&scoped=true"
import script from "./Tippings.vue?vue&type=script&lang=js"
export * from "./Tippings.vue?vue&type=script&lang=js"
import style0 from "./Tippings.vue?vue&type=style&index=0&id=e875e4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e875e4bc",
  null
  
)

export default component.exports